import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'payment-method-added',
  templateUrl: './payment-method-added.component.html',
  styleUrls: ['./payment-method-added.component.scss']
})
export class PaymentMethodAddedComponent implements OnInit {

  ngOnInit() {
    window.close();
  }

}
